import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import DependentProfileViewModel from '../DependentProfile/DependentProfileViewModel'

interface Props {
  vm: DependentProfileViewModel
}

export default observer(function PersonalProfile({ vm }: Props) {
  if (!vm.dependentProfiles) {
    return <></>
  }

  return (
    <div>
      {vm.dependentProfiles.map((profile) => (
        <Section
          key={profile?.id}
          title={`${profile?.personalInfo?.fullName} (${profile?.relationship})`}
          loading={vm.activate.pending}
        >
          <SectionItem
            label="Date of birth"
            value={profile?.personalInfo?.dateOfBirth}
            isSensitive
          />

          <SectionItem
            label="SSN or ITIN"
            value={profile?.personalInfo?.personalTaxpayerIdentificationNumber}
            maskedValue={
              profile?.personalInfo?.personalTaxpayerIdentificationNumberDisplay
            }
            isSensitive
          />
        </Section>
      ))}
    </div>
  )
})
